var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-result-panel"},[_c('div',{staticClass:"search-result__header"},[_c('span'),_c('div',{staticClass:"search-result__header__action"},[_vm._t("searchResultSlot")],2)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }